import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const environment = import.meta.env.VITE_ENVIRONMENT;

const stagingFirebaseConfig = {
  apiKey: "AIzaSyD_SOdL9t-SS9l9EFPcg85kyhcIAn0qKC0",
  authDomain: "kassaro-staging.firebaseapp.com",
  projectId: "kassaro-staging",
  storageBucket: "kassaro-staging.firebasestorage.app",
  messagingSenderId: "1052640768950",
  appId: "1:1052640768950:web:2423925542343c11104717"
};

const prodFirebaseConfig = {
  apiKey: "AIzaSyBnaaTtO3q-7ruTTyA5YvBWdlHv3NFv11I",
  authDomain: "kassaro-prod.firebaseapp.com",
  projectId: "kassaro-prod",
  storageBucket: "kassaro-prod.firebasestorage.app",
  messagingSenderId: "792952385284",
  appId: "1:792952385284:web:a0b3b0b72a11b4cfaaea51"
};

const activeFirebaseConfig =
  environment === "staging" ? stagingFirebaseConfig : prodFirebaseConfig;
const app = initializeApp(activeFirebaseConfig);
export const currentFirebaseProjectId = activeFirebaseConfig.projectId;
export const auth = getAuth(app);
export default app;

